import type { UnityGamePath } from "@/types/global";

export const BACKGAMMON_GAME_PATH: UnityGamePath = {
	LOADER_URL: "/games/Backgammon-3/backgammon.loader.js",
	DATA_URL: "/games/Backgammon-3/backgammon.data.br",
	FRAMEWORK_URL: "/games/Backgammon-3/backgammon.framework.js.br",
	CODE_URL: "/games/Backgammon-3/backgammon.wasm.br",
};
